<template src="@/templates/dhs/popUp.html"></template>

<script>
	import moment from 'moment'

	export default {
		name: "popUp",
		props: ['type', 'userRoles', 'currentRole'],
		watch: {
			invoiceNumber: {
				handler: function (invNumber) {
					this.isFieldEmpty(invNumber);
				},
				deep: true
			},
			jobNumber: {
				handler: function (jobNumber) {
					this.isFieldEmpty(jobNumber);
				},
				deep: true
			},
			dateRange: {
				handler: function (dtRange) {
					if ( dtRange[0]  == '' && dtRange[1] == '') this.isInputFieldEmpty = true;
					else this.isInputFieldEmpty = false;
				},
				deep: true
			}
		},
		data() {
			return {
				viewModal: true,
				modalTitle: '',
				invoiceNumber: '',
				jobNumber: '',
				showInputField: false,
				isInputFieldEmpty: true,
				selectedRole: [],
				userRoleCollection: [],
				dateRange: '',
				dateRangePickerOptions: {
					shortcuts: [{
						text: 'Last week',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: 'Last month',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: 'Last 3 months',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				submitBtnText: 'Submit'
			}
		},
		created() {
			this.selectedRole = this.currentRole;
			this.userRoleCollection = this.userRoles;
			this.submitBtnText = 'Refresh Data';
			
			switch (this.type) {
				case 'unfilled': {
					this.modalTitle = 'Show Unfilled Jobs'; break;
				}
				case 'relief': {
					this.modalTitle = 'Show Relief Interpreter jobs'; break;
				}
				default: {
					this.modalTitle = 'Search Invoiced Records By';
					this.submitBtnText = 'Submit';
					this.showInputField = true;

					let thisComponent = this;
					setTimeout(function () {
						thisComponent.$nextTick(() => thisComponent.$refs.invoiceRef.$el.focus());
					}, 300);
				}
				
			}
		},
		methods: {
			hidePopUp() {
				this.isInputFieldEmpty = true;
				Event.$emit('hidePopUp');
			},
			getRecords() {
				
				if (this.dateRange) {
					this.dateValidation();
				}
				else {
					this.emitData();
				}
			},
			dateValidation() {
				let startDate = this.dateRange[0];
				let endDate = this.dateRange[1];

				startDate = moment(startDate, 'DD-MM-YYYY').unix();
				endDate = moment(endDate, 'DD-MM-YYYY').unix();

				if (startDate > endDate){
					this.$message.error('Invalid Date. Start Date cannot be bigger than end date');
				}
				else {
					this.emitData();
				}
			},
			emitData() {
				Event.$emit('getRecords', this.dateRange, this.selectedRole, this.invoiceNumber, this.jobNumber);
			},
			isFieldEmpty(identifierNumber) {
				if ( identifierNumber == '' || identifierNumber == 0 ) {
					this.isInputFieldEmpty = !(this.invoiceNumber != '' || this.invoiceNumber != 0 || this.jobNumber != '' || this.jobNumber != 0);
				}
				else this.isInputFieldEmpty = false;
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/dhs/popUp.vue